<!--
 © 2025 nSide, Inc. All Rights Reserved.
 This software and its source code are the confidential and proprietary
 information of nSide, Inc. (“Confidential Information”). You may not
 use, reproduce, disclose, distribute, modify, or create derivative works
 of this code except in accordance with a written license agreement or
 other written authorization from nSide, Inc.

 Unauthorized use is strictly prohibited and may result in civil and
 criminal penalties.
-->



<div style="text-align:center; margin-top:20vh; font-size:2vw; color:#f15d22;">
  Error Accessing The nSide|Edge Dashboard
</div>
